module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_diamond_auburn.3d241745.png";